import { pstyle } from "../lib/pstyle.js";

export default function Tools({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:1080px; margin:0 auto; display:flex; flex-direction:column; gap:26px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
        <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Boîte à outils</h1>
        <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>Calculs faits sur place, sans quitter la fiche. Rien n'est envoyé.</p>
      </div>
      <div style={pstyle("display:flex; gap:22px; border-bottom:1px solid oklch(0.94 0.006 85);")}>
        {v.calcTabs.map((t, i) => (
          <button key={i} type="button" onClick={t.onClick} style={pstyle("background:none; border:none; border-bottom-width:2px; border-bottom-style:solid; font:inherit; font-size:13.5px; padding:0 0 10px; margin-bottom:-1px;", { borderBottomColor: t.line, color: t.color, cursor: "pointer" })}>{t.label}</button>
        ))}
      </div>

      {v.isCalcSubnet && (
        <div className="nd-tools-grid" style={pstyle("display:grid; grid-template-columns:minmax(0,1fr) 340px; gap:40px; align-items:start;")}>
          <div style={pstyle("display:flex; flex-direction:column; gap:18px;")}>
            <div style={pstyle("display:flex; flex-direction:column; gap:7px;")}>
              <label htmlFor="calc-cidr" style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Adresse / préfixe</label>
              <input
                id="calc-cidr"
                value={v.cidrInput}
                onChange={v.onCidr}
                placeholder="10.20.30.5/22"
                style={pstyle("border:1px solid oklch(0.9 0.01 85); border-radius:8px; padding:13px 16px; font-family:'IBM Plex Mono', monospace; font-size:16px; color:oklch(0.22 0.012 60); outline:none;")}
              />
              <span style={pstyle("font-size:12.5px;", { color: v.cidrHintColor })}>{v.cidrHint}</span>
            </div>
            <div style={pstyle("display:grid; grid-template-columns:repeat(2, 1fr); gap:1px; background:oklch(0.93 0.008 85); border:1px solid oklch(0.93 0.008 85); border-radius:8px; overflow:hidden;")}>
              {v.subnetRows.map((r, i) => (
                <div key={i} style={pstyle("background:oklch(1 0 0); padding:13px 16px; display:flex; flex-direction:column; gap:3px;")}>
                  <span style={pstyle("font-size:11.5px; letter-spacing:0.04em; text-transform:uppercase; color:oklch(0.53 0.015 60);")}>{r.label}</span>
                  <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:14px; color:oklch(0.24 0.012 60);")}>{r.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={pstyle("display:flex; flex-direction:column; gap:12px;")}>
            <div style={pstyle("display:flex; align-items:baseline; gap:10px;")}>
              <span style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Découper en</span>
              <span style={pstyle("margin-left:auto; display:flex; gap:6px;")}>
                {v.splitOptions.map((o, i) => (
                  <button key={i} type="button" onClick={o.onClick} style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; border-radius:999px; padding:3px 9px; cursor:pointer;", { border: "1px solid " + o.border, color: o.color })}>{o.label}</button>
                ))}
              </span>
            </div>
            <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:8px; overflow:hidden;")}>
              {v.splitRows.map((r, i) => (
                <div key={i} style={pstyle("display:flex; gap:12px; padding:9px 14px; border-bottom:1px solid oklch(0.96 0.006 85); font-family:'IBM Plex Mono', monospace; font-size:12.5px;")}>
                  <span style={pstyle("color:oklch(0.62 0.015 60); width:18px;")}>{r.n}</span>
                  <span style={pstyle("color:oklch(0.26 0.012 60);")}>{r.net}</span>
                  <span style={pstyle("margin-left:auto; color:oklch(0.55 0.015 60);")}>{r.usable}</span>
                </div>
              ))}
            </div>
            <div style={pstyle("font-size:12.5px; line-height:1.6; color:oklch(0.55 0.015 60);")}>{v.splitNote}</div>
          </div>
        </div>
      )}

      {v.isCalcVlsm && (
        <div style={pstyle("display:flex; flex-direction:column; gap:18px;")}>
          <div style={pstyle("display:flex; gap:18px;")}>
            <div style={pstyle("display:flex; flex-direction:column; gap:7px; width:240px;")}>
              <label htmlFor="calc-vlsm-base" style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Bloc de départ</label>
              <input
                id="calc-vlsm-base"
                value={v.vlsmBase}
                onChange={v.onVlsmBase}
                placeholder="10.40.0.0/20"
                style={pstyle("border:1px solid oklch(0.9 0.01 85); border-radius:8px; padding:12px 14px; font-family:'IBM Plex Mono', monospace; font-size:15px; outline:none; color:oklch(0.22 0.012 60);")}
              />
            </div>
            <div style={pstyle("display:flex; flex-direction:column; gap:7px; flex:1;")}>
              <label htmlFor="calc-vlsm-needs" style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Besoins en hôtes (séparés par des virgules)</label>
              <input
                id="calc-vlsm-needs"
                value={v.vlsmNeeds}
                onChange={v.onVlsmNeeds}
                placeholder="500, 200, 60, 30, 2, 2"
                style={pstyle("border:1px solid oklch(0.9 0.01 85); border-radius:8px; padding:12px 14px; font-family:'IBM Plex Mono', monospace; font-size:15px; outline:none; color:oklch(0.22 0.012 60);")}
              />
            </div>
          </div>
          <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:8px; overflow:hidden;")}>
            <div style={pstyle("display:grid; grid-template-columns:60px 120px 1fr 1fr 110px; font-size:12px; font-weight:600; color:oklch(0.5 0.015 60); background:oklch(0.985 0.005 85); border-bottom:1px solid oklch(0.93 0.008 85);")}>
              <span style={pstyle("padding:9px 12px;")}>#</span><span style={pstyle("padding:9px 12px;")}>Demandé</span><span style={pstyle("padding:9px 12px;")}>Préfixe attribué</span><span style={pstyle("padding:9px 12px;")}>Plage utilisable</span><span style={pstyle("padding:9px 12px;")}>Marge</span>
            </div>
            {v.vlsmRows.map((r, i) => (
              <div key={i} style={pstyle("display:grid; grid-template-columns:60px 120px 1fr 1fr 110px; font-size:13px; border-bottom:1px solid oklch(0.96 0.006 85);")}>
                <span style={pstyle("padding:10px 12px; font-family:'IBM Plex Mono', monospace; font-size:12px; color:oklch(0.62 0.015 60);")}>{r.n}</span>
                <span style={pstyle("padding:10px 12px; font-family:'IBM Plex Mono', monospace; font-size:12.5px;")}>{r.need}</span>
                <span style={pstyle("padding:10px 12px; font-family:'IBM Plex Mono', monospace; font-size:12.5px;", { color: r.color })}>{r.prefix}</span>
                <span style={pstyle("padding:10px 12px; font-family:'IBM Plex Mono', monospace; font-size:12px; color:oklch(0.5 0.015 60);")}>{r.range}</span>
                <span style={pstyle("padding:10px 12px; color:oklch(0.55 0.015 60);")}>{r.slack}</span>
              </div>
            ))}
          </div>
          <div style={pstyle("font-size:13px; line-height:1.6; color:oklch(0.5 0.015 60);")}>{v.vlsmNote}</div>
        </div>
      )}

      {v.isCalcMtu && (
        <div style={pstyle("display:grid; grid-template-columns:minmax(0,1fr) 320px; gap:40px; align-items:start;")}>
          <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
            <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Empiler les encapsulations</div>
            {v.mtuOptions.map((o, i) => (
              <button key={i} type="button" onClick={o.onClick} aria-pressed={o.boxFill !== "transparent"} style={pstyle("font:inherit; text-align:left; width:100%; display:flex; align-items:center; gap:14px; padding:11px 14px; border-radius:8px; cursor:pointer;", { border: "1px solid " + o.border, background: o.bg })}>
                <span style={pstyle("width:14px; height:14px; flex:none; border-radius:4px;", { border: "1px solid " + o.boxBorder, background: o.boxFill })}></span>
                <span style={pstyle("font-size:14px; color:oklch(0.28 0.015 60);")}>{o.label}</span>
                <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:12px; color:oklch(0.55 0.015 60);")}>+{o.bytes} o</span>
              </button>
            ))}
          </div>
          <div style={pstyle("display:flex; flex-direction:column; gap:14px;")}>
            <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:8px; padding:18px 20px; display:flex; flex-direction:column; gap:12px;")}>
              {v.mtuResults.map((r, i) => (
                <div key={i} style={pstyle("display:flex; align-items:baseline; gap:10px;")}>
                  <span style={pstyle("font-size:13px; color:oklch(0.5 0.015 60);")}>{r.label}</span>
                  <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:15px;", { color: r.color })}>{r.value}</span>
                </div>
              ))}
            </div>
            <div style={pstyle("font-size:12.5px; line-height:1.65; color:oklch(0.5 0.015 60); text-wrap:pretty;")}>{v.mtuNote}</div>
          </div>
        </div>
      )}
    </div>
  );
}
